<template>
  <select class="select2-control hidden">
    <slot></slot>
  </select>
</template>

<script>
import "select2";
import "select2/dist/css/select2.css";

export default {
  name: "Select2",
  props: {
    value: {
      default: null,
    },
    width: {
      type: String,
      default: "100%",
    },
    placeholder: {
      // Example object: { id: '', text: 'Please select an entry...' }
      // id is the value of the option
      // an empty option needs to be added to the list
      // If only a string is provided, the placeholder will appear for any value that no option exists for
      type: [Object, String],
      default: null,
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Boolean,
      default: false,
    },
    minimumInputLength: {
      type: Number,
      default: 0,
    },
    noResultsString: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.initSelect2();
  },
  watch: {
    value(value) {
      if (this.tags) this.addTaggedValues();
      $(this.$el).val(value).trigger("change.select2");
    },
    placeholder(value) {
      this.initSelect2();
    },
    allowClear() {
      this.initSelect2();
    },
    multiple() {
      this.initSelect2();
    },
    tags() {
      this.initSelect2();
    },
    minimumInputLength() {
      this.initSelect2();
    },
  },
  destroyed() {
    this.destroySelect2();
  },
  methods: {
    addTaggedValues() {
      if (this.multiple)
        for (let val of this.value) {
          if (!this.isValueInOptions(val)) this.addCustomValueToOptions(val);
        }
      else if (!this.isValueInOptions(this.value))
        this.addCustomValueToOptions(this.value);
    },
    isValueInOptions(value) {
      let options = $(this.$el).find("option");
      for (let option of options) {
        if (value === option.value) return true;
      }
      return false;
    },
    addCustomValueToOptions(value) {
      $(this.$el).append(new Option(value, value));
    },
    updateValue() {
      this.$nextTick(() => {
        $(this.$el).val(this.value).trigger("change.select2");
      });
    },
    reinit() {
      this.$nextTick(() => {
        this.destroySelect2();
        this.initSelect2();
      });
    },
    destroySelect2() {
      $(this.$el).off().select2("destroy");
    },
    open() {
      $(this.$el).select2("open");
    },
    close() {
      $(this.$el).select2("close");
    },
    initSelect2() {
      let vm = this;
      let options = {
        width: this.width,
        allowClear: this.allowClear,
        tags: this.tags,
        multiple: this.multiple,
        language: {
          noResults: () => {
            return this.noResultsString || this.globals.lang.G00000;
          },
        },
      };
      if (this.placeholder) options.placeholder = this.placeholder;
      if (this.tags) options.tokenSeparators = [",", " "];
      if (this.minimumInputLength)
        options.minimumInputLength = this.minimumInputLength;

      // If this select was already initialized before, events are already registered
      let alreadyInitialized = $(this.$el).hasClass(
        "select2-hidden-accessible"
      );

      $(this.$el)
        // init select2
        .select2(options)
        .val(this.value)
        .trigger("change.select2");

      if (this.tags && this.value) {
        this.addTaggedValues();
        this.updateValue();
      }

      if (!alreadyInitialized) {
        // emit event on change.
        $(this.$el)
          .on("change", function (event) {
            let result;
            if (!vm.multiple) result = this.value;
            else {
              let selected = $(this).select2("data");
              result = [];
              for (let option of selected) {
                result.push(option.id);
              }
            }
            vm.$emit("input", result, event);
            vm.$emit("change", result, event);
          })
          .focus(function () {
            $(this).select2("open");
          });

        $(this.$el).on("select2:open", function (e) {
          vm.$emit("open", e);
        });

        $(this.$el).on("select2:opening", function (e) {
          vm.$emit("beforeOpen", e);
        });

        $(this.$el).on("select2:close", function (e) {
          vm.$emit("close", e);
        });
      }
    },
  },
};
</script>

<style>
.select2-control ~ .select2.select2-container {
  margin: 3px 0 7px 0;
  padding-top: 7px;
  float: left;
}
.select2-container--default.select2-container--focus
  .select2-selection--multiple {
  border: none;
}
.select2-control ~ .select2-container--default .select2-selection {
  border: solid #d2d2d2 !important;
  border-width: 0 0 1px 0 !important;
  border-radius: 0 !important;
  min-height: 28px;
  line-height: normal;
}
.select2-control ~ .select2-container--default .select2-selection__choice {
  border: 1px solid #d2d2d2 !important;
  border-radius: 0 !important;
  margin-top: 4px !important;
}
.select2-control ~ .select2-container--default .select2-selection__rendered {
  text-align: left;
  font-size: 16px;
}
.select2-control ~ .select2-container--default .select2-selection__arrow {
  top: 7px !important;
}
.select2-control ~ .select2-container--disabled .select2-selection {
  cursor: not-allowed !important;
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  border: solid #d2d2d2 !important;
  border-width: 0 0 1px 0 !important;
}
.select2-container--default
  .select2-selection--single
  .select2-selection__placeholder {
  color: lightgray !important;
}
.select2-container--default
  .select2-search--inline
  .select2-search__field::placeholder {
  color: lightgray !important;
}
.select2-container--default .select2-results__option[aria-disabled="true"] {
  color: lightgray !important;
}
.select2-container--default > .select2-dropdown {
  border-radius: 0 !important;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__clear {
  margin-top: 4px !important;
}

.select2-container--open .select2-dropdown--above {
  border-bottom: 1px solid #ddd !important;
}

@media (max-width: 1000px) {
  .select2-container--default > .select2-dropdown {
    /* width: calc(100vw - 150px) !important; */
    font-size: 1.4em !important;
  }
  .select2-container--default .select2-results > .select2-results__options {
    max-height: 10em;
  }

  .select2-container {
    font-size: 2em;
  }
  .select2-control ~ .select2-container--default .select2-selection__rendered {
    font-size: 0.6em;
    line-height: 1.2em;
  }

  .select2-container .select2-selection--single {
    height: 0.8em;
  }

  .select2-container--default .select2-selection__clear {
    font-size: 1.5em;
    transform: translateX(-10px);
  }
  .select2-container--default
    .select2-selection--multiple
    .select2-selection__clear {
    transform: translateY(10px);
  }
  .select2-container--default .select2-selection__arrow > b {
    border-width: 15px 12px 0 12px !important;
    top: 0.25em !important;
    transform: translateX(-10px);
  }
  .select2-container--default.select2-container--open
    .select2-selection__arrow
    b {
    border-width: 0 12px 15px 12px !important;
  }

  .select2-container--default
    .select2-selection--multiple
    .select2-selection__choice__remove {
    font-size: 1.5em;
    transform: translateY(5px);
  }
}
</style>



// WEBPACK FOOTER //
// Select2.vue?70129585